export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_RESPONSE = "GET_CATEGORIES_RESPONSE";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
